import { Address } from '@quick/client';
import { Control, Controller } from 'react-hook-form';
import React from 'react';
import { Col, Form, Input, Row } from 'antd';
import { GUTTER } from './Gutter';
import USStateSelect from './USStateSelect';

type AddressFormItemsValues = {
  fullAddress: Address;
};

interface AddressFormItemsProps {
  control: Control<AddressFormItemsValues>;
}

const AddressFormItems: React.FC<AddressFormItemsProps> = ({ control }) => {
  return (
    <Form.Item required label="Address">
      <Controller
        control={control}
        name="fullAddress.line1"
        rules={{
          required: 'Address line1 is required',
        }}
        render={({ field, fieldState }) => (
          <Form.Item required validateStatus={fieldState.error && 'error'} help={fieldState.error?.message}>
            <Input placeholder="Address line 1" {...field} />
          </Form.Item>
        )}
      />
      <Controller
        control={control}
        name="fullAddress.line2"
        render={({ field, fieldState }) => (
          <Form.Item validateStatus={fieldState.error && 'error'} help={fieldState.error?.message}>
            <Input placeholder="Address line 2" {...field} />
          </Form.Item>
        )}
      />
      <Controller
        control={control}
        name="fullAddress.city"
        rules={{
          required: 'Address city is required',
        }}
        render={({ field, fieldState }) => (
          <Form.Item required validateStatus={fieldState.error && 'error'} help={fieldState.error?.message}>
            <Input placeholder="City" {...field} />
          </Form.Item>
        )}
      />
      <Row gutter={GUTTER}>
        <Col span={12}>
          <Controller
            control={control}
            name="fullAddress.state"
            rules={{
              required: 'Address state is required',
            }}
            render={({ field, fieldState }) => (
              <Form.Item required validateStatus={fieldState.error && 'error'} help={fieldState.error?.message}>
                <USStateSelect placeholder="State" {...field} />
              </Form.Item>
            )}
          />
        </Col>
        <Col span={12}>
          <Controller
            control={control}
            name="fullAddress.zipcode"
            rules={{
              required: 'Address zipcode is required',
            }}
            render={({ field, fieldState }) => (
              <Form.Item required validateStatus={fieldState.error && 'error'} help={fieldState.error?.message}>
                <Input placeholder="Zipcode" {...field} />
              </Form.Item>
            )}
          />
        </Col>
      </Row>
    </Form.Item>
  );
};

export default AddressFormItems;
